var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { IconButtonAFY, icons, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import { formattedDate } from "../../../utils/date";
export var options = [
    { value: '0', name: 'Documento' },
    { value: '1', name: 'Nombre' },
    { value: '2', name: 'Apellido' },
    { value: '3', name: 'Email' },
];
export var columns = function (handleClickSeeDetails, hasPermission) { return [
    {
        field: "actions",
        headerName: "",
        width: 80,
        renderCell: function (params) { return (_jsx("div", __assign({ style: { display: "flex", gap: "10px" } }, { children: _jsx(IconButtonAFY, { bgColorIconButton: "#F4F8FA", icon: icons.Search, iconColor: "#006ac6", title: "Ver detalles", onClick: function () { return handleClickSeeDetails(params.row); }, disabled: !hasPermission("customer-detail") }) }))); },
    },
    {
        field: 'documentId',
        flex: 1,
        headerName: 'Documento',
        width: 150
    },
    {
        field: 'fullName',
        flex: 1,
        headerName: 'Nombre completo',
        width: 150
    },
    {
        field: 'email',
        flex: 1,
        headerName: 'Email',
        width: 160
    },
    {
        field: 'phone',
        flex: 1,
        headerName: 'Teléfono',
        width: 150
    },
    {
        field: 'dob',
        flex: 1,
        headerName: 'Fecha Nacimiento',
        width: 150,
        renderCell: function (params) { return (_jsx("div", { children: params.value ? formattedDate(params.value) : "" })); }
    },
]; };
